/* ============================================================
   ANTI — theme.js
   Native custom elements, no libraries.
   ============================================================ */
(function () {
  'use strict';

  var routes = (window.routes = window.routes || {});
  var moneyCode = (window.themeMoney && window.themeMoney.code) || 'USD';
  var strings = window.themeStrings || { addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable' };

  /* ---------- helpers ---------- */
  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: moneyCode }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  /* iOS ignores overflow:hidden on body, so pin it and restore the offset on close.
     Ref-counted because the menu and the drawer can both be open in sequence. */
  var scrollLockY = 0, scrollLocks = 0;
  function lockScroll(on) {
    var body = document.body;
    if (on) {
      scrollLocks++;
      if (scrollLocks > 1) return;
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      body.style.position = 'fixed';
      body.style.top = '-' + scrollLockY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    } else {
      scrollLocks = Math.max(0, scrollLocks - 1);
      if (scrollLocks > 0) return;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      window.scrollTo(0, scrollLockY);
    }
  }
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])';
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var nodes = Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE)).filter(function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function cartState() { return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function cartDrawerHTML() { return fetch(routes.cart_url + '?section_id=cart-drawer').then(function (r) { return r.text(); }); }

  /* Meta Pixel AddToCart. No-ops unless the pixel snippet actually rendered,
     so clearing the Pixel ID in theme settings removes this too. */
  function trackAddToCart(item) {
    if (!window.fbq || !item) return;
    try {
      fbq('track', 'AddToCart', {
        content_ids: [item.id],
        content_type: 'product',
        content_name: item.product_title || item.title,
        value: (item.price || 0) / 100,
        currency: moneyCode
      });
    } catch (e) {}
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  /* ---------- sticky header ---------- */
  customElements.define('sticky-header', class extends HTMLElement {
    connectedCallback() {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
    onScroll() {
      if (window.scrollY > 8) this.setAttribute('data-scrolled', '');
      else this.removeAttribute('data-scrolled');
    }
  });

  /* ---------- generic overlay open/close ---------- */
  function makeOverlay(el, opts) {
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      el.hidden = false;
      requestAnimationFrame(function () { el.setAttribute('data-open', ''); });
      lockScroll(true);
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      var focusTarget = el.querySelector(opts.focus) || el.querySelector(FOCUSABLE);
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
      if (opts.onOpen) opts.onOpen();
    }
    function close() {
      el.removeAttribute('data-open');
      lockScroll(false);
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { el.hidden = true; }, 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (el.hasAttribute('data-open')) trapFocus(el, e);
    });
    return { open: open, close: close };
  }

  function wireTriggers(toggleAttr, closeAttr, getOverlay) {
    document.addEventListener('click', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var t = e.target.closest('[' + toggleAttr + ']');
      if (t) { e.preventDefault(); var o = getOverlay(); if (o) o.open(); return; }
      // Every caller passes '' here; without this guard closest('[]') throws on
      // every click that isn't a toggle.
      if (!closeAttr) return;
      var c = e.target.closest('[' + closeAttr + ']');
      if (c) { e.preventDefault(); var o2 = getOverlay(); if (o2) o2.close(); }
    });
  }

  /* ---------- overlay menu ---------- */
  customElements.define('overlay-menu', class extends HTMLElement {
    connectedCallback() {
      this.ctrl = makeOverlay(this, { focus: '[data-menu-close]' });
      this.querySelectorAll('[data-menu-close]').forEach((b) => b.addEventListener('click', () => this.ctrl.close()));
    }
    open() { this.ctrl.open(); }
    close() { this.ctrl.close(); }
  });
  wireTriggers('data-menu-toggle', '', function () { return document.querySelector('overlay-menu'); });

  /* ---------- predictive search ---------- */
  customElements.define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.ctrl = makeOverlay(this, { focus: '[data-search-input]' });
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', () => this.ctrl.close()));
      var timer;
      if (this.input) this.input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => this.search(), 250); });
    }
    open() { this.ctrl.open(); }
    close() { this.ctrl.close(); }
    search() {
      var q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; return; }
      var url = routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { this.results.innerHTML = '<p class="predictive-results__empty">Nothing found.</p>'; return; }
          var html = '<ul class="predictive-results" role="list">' + products.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            var price = (typeof p.price === 'number') ? money(p.price) : (p.price || '');
            return '<li class="predictive-result"><a class="predictive-result__link" href="' + p.url + '">' +
              '<span class="predictive-result__media">' + (img ? '<img src="' + img + '" alt="" width="60" height="75" loading="lazy">' : '') + '</span>' +
              '<span class="predictive-result__title">' + p.title + '</span>' +
              '<span class="predictive-result__price">' + price + '</span></a></li>';
          }).join('') + '</ul>';
          this.results.innerHTML = html;
        })
        .catch(() => { this.results.innerHTML = ''; });
    }
  });
  wireTriggers('data-search-toggle', '', function () { return document.querySelector('predictive-search'); });

  /* ---------- cart drawer ---------- */
  customElements.define('cart-drawer', class extends HTMLElement {
    connectedCallback() {
      this.ctrl = makeOverlay(this, { focus: '[data-cart-close]' });
      this.itemsRegion = this.querySelector('[data-cart-items]');
      this.footer = this.querySelector('[data-cart-footer]');
      this.bind();
    }
    open() { this.ctrl.open(); }
    close() { this.ctrl.close(); }
    bind() {
      this.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', () => this.ctrl.close()));
      this.addEventListener('click', (e) => {
        var rm = e.target.closest('[data-cart-remove]');
        if (rm) { e.preventDefault(); this.change(parseInt(rm.getAttribute('data-line'), 10), 0); }
      });
      this.querySelectorAll('quantity-input').forEach((q) => q.attach(this));
    }
    refresh() {
      return Promise.all([cartDrawerHTML(), cartState()]).then((res) => {
        var doc = new DOMParser().parseFromString(res[0], 'text/html');
        var newItems = doc.querySelector('[data-cart-items]');
        var newFooter = doc.querySelector('[data-cart-footer]');
        if (newItems && this.itemsRegion) this.itemsRegion.innerHTML = newItems.innerHTML;
        if (newFooter && this.footer) {
          this.footer.innerHTML = newFooter.innerHTML;
          if (newFooter.hasAttribute('hidden')) this.footer.setAttribute('hidden', ''); else this.footer.removeAttribute('hidden');
        }
        updateCartCount(res[1].item_count);
        this.bind();
      });
    }
    change(line, quantity) {
      fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(() => this.refresh());
    }
  });
  wireTriggers('data-cart-toggle', '', function () { return document.querySelector('cart-drawer'); });

  function openCartDrawer() { var d = document.querySelector('cart-drawer'); if (d) d.open(); }
  function refreshCartDrawer() { var d = document.querySelector('cart-drawer'); return d ? d.refresh() : cartState().then((c) => updateCartCount(c.item_count)); }

  /* ---------- quantity input ---------- */
  customElements.define('quantity-input', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-input]');
      this.line = parseInt(this.getAttribute('data-line'), 10);
      this.querySelector('[name="plus"]').addEventListener('click', () => this.step(1));
      this.querySelector('[name="minus"]').addEventListener('click', () => this.step(-1));
      this.input.addEventListener('change', () => this.commit(parseInt(this.input.value, 10) || 0));
    }
    attach(drawer) { this.drawer = drawer; }
    step(dir) { this.commit(Math.max(0, (parseInt(this.input.value, 10) || 0) + dir)); }
    commit(qty) {
      var drawer = this.drawer || this.closest('cart-drawer');
      if (drawer) drawer.change(this.line, qty);
    }
  });

  /* ---------- terms agreement gate ---------- */
  var TERMS_KEY = 'anti:terms-accepted';

  function termsRead() {
    try { var v = sessionStorage.getItem(TERMS_KEY); return v === null ? null : v === '1'; }
    catch (e) { return null; }
  }
  function termsWrite(on) {
    try { sessionStorage.setItem(TERMS_KEY, on ? '1' : '0'); } catch (e) {}
  }
  function termsSaveAttribute(on) {
    if (!routes.cart_update_url) return;
    fetch(routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Terms Accepted': on ? 'Yes' : '' } })
    }).catch(function () {});
  }
  function termsSyncAll(source) {
    document.querySelectorAll('terms-gate').forEach(function (g) {
      if (g !== source && g.setAccepted) g.setAccepted(source.accepted(), true);
      else if (g.sync) g.sync();
    });
  }

  customElements.define('terms-gate', class extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('[data-terms-checkbox]');
      this.errorEl = this.querySelector('[data-terms-error]');
      this.scope = this.closest('[data-terms-scope]') || this.parentElement;
      if (!this.box) return;

      var remembered = termsRead();
      if (remembered !== null) this.box.checked = remembered;

      // A link inside the label would otherwise toggle the box on its way out.
      this.querySelectorAll('.terms-agreement__label a').forEach(function (a) {
        a.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); window.open(a.href, a.target || '_self'); });
      });

      this.box.addEventListener('change', () => {
        termsWrite(this.box.checked);
        termsSaveAttribute(this.box.checked);
        this.hideError();
        this.sync();
        termsSyncAll(this);
      });

      if (this.scope && !this.scope.__termsBound) {
        this.scope.__termsBound = true;
        this.scope.addEventListener('click', (e) => {
          var gate = this.scope.querySelector('terms-gate');
          if (!gate || gate.accepted()) return;
          if (!e.target.closest('[data-terms-gated], [data-terms-shield]')) return;
          e.preventDefault();
          e.stopPropagation();
          gate.reject();
        }, true);
      }

      this.sync();
    }
    accepted() { return !!(this.box && this.box.checked); }
    setAccepted(on, silent) {
      if (!this.box || this.box.checked === on) return;
      this.box.checked = on;
      if (on) this.hideError();
      this.sync();
      if (!silent) { termsWrite(on); termsSaveAttribute(on); }
    }
    sync() {
      var ok = this.accepted();
      if (!this.scope) return;
      this.scope.classList.toggle('terms-locked', !ok);
      this.scope.querySelectorAll('[data-terms-gated]').forEach(function (el) {
        if (el.tagName === 'BUTTON' || el.tagName === 'A') el.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
      this.scope.querySelectorAll('[data-terms-shield]').forEach(function (el) { el.hidden = ok; });
    }
    reject() {
      if (this.errorEl) this.errorEl.hidden = false;
      if (this.box) { this.box.focus(); }
      this.classList.remove('terms-agreement--nudge');
      void this.offsetWidth;
      this.classList.add('terms-agreement--nudge');
    }
    hideError() { if (this.errorEl) this.errorEl.hidden = true; }
  });

  /* ---------- product form (AJAX add) ---------- */
  customElements.define('product-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.spinner = this.querySelector('.button__spinner');
      if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
    }
    submit(e) {
      e.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;
      this.loading(true);
      var data = new FormData(this.form);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);
      fetch(routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) { this.loading(false); return; }
          trackAddToCart(res);
          return refreshCartDrawer().then(function () { openCartDrawer(); });
        })
        .then(() => this.loading(false))
        .catch(() => this.loading(false));
    }
    loading(on) {
      this.button.classList.toggle('is-loading', on);
      if (this.spinner) this.spinner.hidden = !on;
    }
  });

  /* ---------- product gallery carousel ---------- */
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  customElements.define('product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-slide]'));
      if (!this.track || this.slides.length < 2) return;

      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-dot]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
      this.counter = this.querySelector('[data-gallery-current]');
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.index = 0;

      var mapEl = this.querySelector('[data-gallery-variant-map]');
      try { this.variantMedia = mapEl ? JSON.parse(mapEl.textContent) : {}; }
      catch (e) { this.variantMedia = {}; }

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));

      this.dots.concat(this.thumbs).forEach((b) => {
        b.addEventListener('click', () => this.go(parseInt(b.getAttribute('data-index'), 10) || 0));
      });

      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
      });

      // Native scroll is the source of truth — swipe on touch needs no JS at all.
      var frame = null;
      this.track.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = null; this.readScroll(); });
      }, { passive: true });

      // Orientation change / resize would otherwise leave the track mid-slide.
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => { this.track.scrollLeft = this.track.clientWidth * this.index; }, 120);
      };
      window.addEventListener('resize', this.onResize);

      this.onVariant = (e) => {
        var v = e.detail && e.detail.variant;
        if (!v) return;
        var mediaId = this.variantMedia[v.id];
        if (mediaId === undefined || mediaId === null) return;
        for (var i = 0; i < this.slides.length; i++) {
          if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { this.go(i); return; }
        }
      };
      document.addEventListener('anti:variant:change', this.onVariant);

      this.sync();
    }
    disconnectedCallback() {
      if (this.onVariant) document.removeEventListener('anti:variant:change', this.onVariant);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      clearTimeout(this.resizeTimer);
    }
    clamp(i) { return Math.max(0, Math.min(this.slides.length - 1, i)); }
    go(i) {
      i = this.clamp(i);
      var left = this.track.clientWidth * i;
      try { this.track.scrollTo({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' }); }
      catch (e) { this.track.scrollLeft = left; }
      this.index = i;
      this.sync();
    }
    readScroll() {
      var w = this.track.clientWidth;
      if (!w) return;
      var i = this.clamp(Math.round(this.track.scrollLeft / w));
      if (i === this.index) return;
      this.index = i;
      this.sync();
    }
    sync() {
      var i = this.index, last = this.slides.length - 1;
      if (this.counter) this.counter.textContent = i + 1;
      if (this.prevBtn) this.prevBtn.disabled = i === 0;
      if (this.nextBtn) this.nextBtn.disabled = i === last;
      this.dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      this.thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
  });

  /* ---------- variant picker ---------- */
  customElements.define('variant-picker', class extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-variant-json]');
      try { this.variants = JSON.parse(json.textContent); } catch (e) { this.variants = []; }
      this.section = this.getAttribute('data-section-id');
      this.addEventListener('change', () => this.onChange());
    }
    selectedOptions() {
      return Array.prototype.map.call(this.querySelectorAll('.variant-picker__input:checked'), function (i) { return i.value; });
    }
    onChange() {
      var opts = this.selectedOptions();
      var match = this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var form = document.getElementById('product-form-' + this.section);
      var idInput = form ? form.querySelector('[data-variant-id]') : document.querySelector('[data-variant-id]');
      var addLabel = document.querySelector('[data-add-label]');
      var addBtn = addLabel ? addLabel.closest('button') : null;
      var priceEl = document.querySelector('.product__price .price__now') || document.querySelector('.product__price .price');

      if (!match) {
        if (addLabel) addLabel.textContent = strings.unavailable;
        if (addBtn) { addBtn.setAttribute('disabled', ''); addBtn.setAttribute('aria-disabled', 'true'); }
        return;
      }
      if (idInput) { idInput.value = match.id; idInput.removeAttribute('disabled'); }
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        if (match.available) {
          addBtn.removeAttribute('disabled'); addBtn.removeAttribute('aria-disabled');
          if (addLabel) addLabel.textContent = strings.addToCart;
        } else {
          addBtn.setAttribute('disabled', ''); addBtn.setAttribute('aria-disabled', 'true');
          if (addLabel) addLabel.textContent = strings.soldOut;
        }
      }
      document.dispatchEvent(new CustomEvent('anti:variant:change', {
        detail: { variant: match, section: this.section }
      }));
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }
  });

  // keep header count in sync on load
  document.addEventListener('DOMContentLoaded', function () {
    cartState().then(function (c) { updateCartCount(c.item_count); }).catch(function () {});
  });
})();
